import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

export function useLanguages(options = {}) {
  return useQuery({
    queryKey: ["languages"],
    queryFn: async () => {
      const fields = ["name", "code", "active"].join(",");

      const params = {
        fields,
        sort: "name",
        limit: "1000", // Get all languages
      };

      const json = await getJson("/items/languages", params);
      return json?.data || [];
    },
    staleTime: 300_000, // 5 minutes
    refetchOnWindowFocus: false,
    ...options,
  });
}

export default useLanguages;
